import React from 'react';
import { Instagram, MessageCircle, MapPin, Phone, Mail } from 'lucide-react';
interface FooterProps {
  onNavigate: (page: 'home' | 'rental') => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer id="footer" className="bg-dark-studio text-white pt-16 pb-8 border-t border-white/10" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-65">
          {/* Brand */}
          <div className="space-y-4 md:col-span-1" data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/uuj9K1QQaCS9sqRx6P8ACg/Pink_Neon_Illustrate.png" alt="Flex Club Stretching Studio" className="h-14 w-auto object-contain" data-id="element-67" />
            <p className="text-gray-400 leading-relaxed text-sm" data-id="element-68">
              Dein Boutique Studio für Stretching, Mobility und Fitness in
              Nürnberg.
            </p>
            <div className="flex space-x-4 pt-2" data-id="element-69">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-peony-500 hover:text-white transition-all duration-300" data-id="element-70">
                <Instagram size={20} data-id="element-71" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-green-500 hover:text-white transition-all duration-300" data-id="element-72">
                <MessageCircle size={20} data-id="element-73" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-74">
            <h4 className="text-lg font-bold mb-6 text-peony-200" data-id="element-75">Kurse</h4>
            <ul className="space-y-3 text-gray-400 text-sm" data-id="element-76">
              <li data-id="element-77">
                <a href="#courses" className="hover:text-white transition-colors" data-id="element-78">
                  Spagat School
                </a>
              </li>
              <li data-id="element-79">
                <a href="#courses" className="hover:text-white transition-colors" data-id="element-80">
                  Aerial Stretching
                </a>
              </li>
              <li data-id="element-81">
                <a href="#courses" className="hover:text-white transition-colors" data-id="element-82">
                  Gesunder Rücken
                </a>
              </li>
              <li data-id="element-83">
                <a href="#courses" className="hover:text-white transition-colors" data-id="element-84">
                  Functional Training
                </a>
              </li>
              <li data-id="element-85">
                <a href="#courses" className="hover:text-white transition-colors" data-id="element-86">
                  Tanz Dich Frei
                </a>
              </li>
            </ul>
          </div>

          {/* Studio */}
          <div data-id="element-87">
            <h4 className="text-lg font-bold mb-6 text-peony-200" data-id="element-88">Studio</h4>
            <ul className="space-y-3 text-gray-400 text-sm" data-id="element-89">
              <li data-id="element-90">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-91">
                  Über uns
                </a>
              </li>
              <li data-id="element-92">
                <a href="#team" className="hover:text-white transition-colors" data-id="element-93">
                  Unser Team
                </a>
              </li>
              <li data-id="element-94">
                <a href="#preise" className="hover:text-white transition-colors" data-id="element-95">
                  Preise
                </a>
              </li>
              <li data-id="element-96">
                <button onClick={() => onNavigate('rental')} className="hover:text-white transition-colors text-left" data-id="element-97">
                  Studio mieten
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-98">
            <h4 className="text-lg font-bold mb-6 text-peony-200" data-id="element-99">Kontakt</h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-100">
              <li className="flex items-start space-x-3" data-id="element-101">
                <MapPin size={18} className="text-peony-500 flex-shrink-0 mt-0.5" data-id="element-102" />
                <span data-id="element-103">
                  Musterstraße 12
                  <br data-id="element-104" />
                  90402 Nürnberg
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-105">
                <Phone size={18} className="text-peony-500 flex-shrink-0" data-id="element-106" />
                <span data-id="element-107">+49 911 123456</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-108">
                <Mail size={18} className="text-peony-500 flex-shrink-0" data-id="element-109" />
                <span data-id="element-110">hello@flexandflow-nbg.de</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-gray-500 text-sm" data-id="element-111">
          <p data-id="element-112">
            &copy; {new Date().getFullYear()} Flex Club Nürnberg. Alle Rechte
            vorbehalten.
          </p>
        </div>
      </div>
    </footer>;
}